module.exports = __webpack_public_path__ + "media/theme/icon__instock-ff302812.png";